import { ServerProduct, ServerStock } from '@/lib/janitsjar/Product';
import type { FagmoblerInventory } from '@fagmobler/types';
import { useStores } from '@/components/store';

export type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

export const serverProductToFagmoblerInventory = (
  product: ServerProduct
): FagmoblerInventory => {
  return (
    product.stock?.reduce((acc, stockItem) => {
      return {
        ...acc,
        [product.sku]: {
          [stockItem.storeId]: {
            display: stockItem.display,
            stock: stockItem.stock,
          },
        },
      };
    }, {}) || {}
  );
};

export const useCurrentStoreStock = (stock: ServerStock) => {
  const currentStore = useCurrentStore();

  if (!currentStore) return null;

  return stock.find((s) => s.storeId === currentStore.id) || null;
};

export const useCurrentStore = () => {
  const { current: currentStoreQuery } = useStores();
  const currentStore = currentStoreQuery.data?.store;

  return currentStore ?? null;
};
